import React from "react";
import i18next from "i18next";

const baseClass = "d-flex align-items-center justify-content-center align-middle";
const buttonClass = `${baseClass} border rounded-circle text-light c-pointer`;
const textClass = `${baseClass} text-primary`;

const elSize = 25;
const buttonStyle = {width: elSize, height: elSize, paddingBottom: 2};
const textStyle = {height: elSize, padding: '0px 5px 3px 5px'}

const defaultFontSize = 11;
const localStorageName = "ARGridFontSize";

export const setArGridFontSize = (size) => {
  localStorage.setItem(localStorageName, size);
}

export const getArGridFontSize = () => {
  return  parseInt(localStorage.getItem(localStorageName)) || defaultFontSize;
}

const ARGridFontSize = ({fontSize, changeHandler}) => {

  return (
    <>
      <div className={'d-flex border rounded-pill border-primary mb-auto p-1'} style={{maxWidth: "116px"}}>
        <div className={`${buttonClass} bg-primary`} style={buttonStyle} onClick={() => changeHandler(fontSize - 1)}>-</div>
        <div className={textClass} style={textStyle}>{i18next.t('Font')}</div>
        <div className={`${buttonClass} bg-success`} style={buttonStyle} onClick={() => changeHandler(fontSize + 1)}>+</div>
      </div>
    </>
  );
}

export default ARGridFontSize;